import React from "react";
import { Select } from "antd";
import IconFont from "@/components/icon";
const { Option } = Select;

const limits = [1000, 2000, 5000, 10000, 20000, 50000, 100000];

export default function (props: { onChange: any; defaultValue?: number; value: number }) {
  return (
    <Select
      style={{ width: "100%" }}
      defaultValue={props.defaultValue || 1000}
      placeholder="请选择观看数量上限"
      showArrow={true}
      value={props.value}
      suffixIcon={<IconFont type="iconicon_down" className="anticon-down icon-more icon-toggle" />}
      onChange={props.onChange}
      className="calendar-custom-select calendar-custom-select-arrow"
    >
      {limits.map((limit: any, index: number) => {
        return (
          <Option key={index} value={limit}>
            观看数量上限{limit}
          </Option>
        );
      })}
    </Select>
  );
}
